export enum EKwikUIInputPhoneSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputPhoneSize = [
  EKwikUIInputPhoneSize.S,
  EKwikUIInputPhoneSize.M,
  EKwikUIInputPhoneSize.L
] as const;

export type TKwikUIInputPhoneSize = (typeof VKwikUIInputPhoneSize)[number];
